import React, { useState } from 'react';
import { Form } from '../../../ui/universe';
import { TagInput, Tooltip } from 'tdesign-react';
import OcrTag from '../../../ui/Tag/index.jsx';
import FieldConfigDrawer from './FieldConfigDrawer';
import { splitByCommas, removeLastByType } from '../../../../utils/index.js';
import '../../../../style/AdvancedTagInput.css';

/**
 * 标签输入参数渲染器
 * 支持普通模式和高级配置模式
 */
function InputTagRenderer({
  params,
  value,
  tags,
  defaultTags,
  currentKey,
  setCurrentKey,
  showConfirm,
  setShowConfirm,
  onChange,
  useAdvanced = false,
}) {
  // 高级模式下的字段配置抽屉状态
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentFieldIndex, setCurrentFieldIndex] = useState(null);
  const [drawerKey, setDrawerKey] = useState(0);

  const currentFieldData =
    currentFieldIndex !== null ? value[currentFieldIndex] : null;

  const handleOpenSettings = (index, e) => {
    e.stopPropagation();
    setCurrentFieldIndex(index);
    setDrawerKey((prev) => prev + 1);
    setDrawerVisible(true);
  };

  const handleDrawerConfirm = (formData) => {
    if (currentFieldIndex !== null) {
      const newVal = [...value];
      newVal[currentFieldIndex] = {
        ...newVal[currentFieldIndex],
        KeyName: formData.KeyName,
        KeyPrompt: formData.KeyPrompt,
        KeyExpectedValue: formData.KeyExpectedValue,
        KeyAuditPrompt: formData.KeyAuditPrompt,
      };
      onChange(newVal);
    }
    setCurrentFieldIndex(null);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
    setCurrentFieldIndex(null);
  };

  return (
    <>
      {params.labelList?.map((label) => (
        <Form.Item
          key={label.KeyType}
          className={`${params.LabelAlign ? 'column' : 'row'}`}
          label={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>{label.label}</span>
              {label.des && (
                <Tooltip content={label.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              )}
            </div>
          }
        >
          <TagInput
            value={tags}
            disabled={showConfirm}
            placeholder="输入字段名，多个字段用逗号分隔"
            excessTagsDisplayType="break-line"
            size="medium"
            onChange={(e, cur) => {
              if (cur.e.keyCode === 8 || cur.e.keyCode === 46) {
                const _val = removeLastByType(value, label.KeyType, 'KeyType');
                onChange(_val);
              } else {
                if (!e.length) return;
                const _curVal = splitByCommas(cur.item);
                const _val = value;
                _curVal.map((i) => {
                  const newItem = {
                    KeyName: i,
                    KeyType: label.KeyType,
                    KeyPrompt: ''
                  };
                  if (useAdvanced) {
                    newItem.KeyExpectedValue = '';
                    newItem.KeyAuditPrompt = '';
                  }
                  _val.push(newItem);
                });
                onChange(_val);
              }
            }}
            onClear={() => {
              const _val = value.filter((i) => i.KeyType !== label.KeyType);
              onChange(_val);
            }}
            valueDisplay={({ value: displayTags }) =>
              displayTags?.map((item, index) => {
                if (value[index]?.KeyType !== label.KeyType) {
                  return null;
                }
                return (
                  <OcrTag
                    key={index}
                    keyVal={index}
                    currentKey={currentKey}
                    maxPrompt={params.KeyPromptMax}
                    keyPrompt={value[index]?.KeyPrompt}
                    onConfirm={(val) => {
                      const _val = value;
                      _val[index].KeyPrompt = val.KeyPrompt;
                      onChange(_val);
                    }}
                    onChoose={(e) => {
                      setCurrentKey(e);
                    }}
                    setShowConfirm={(val) => {
                      setShowConfirm(val);
                      if (!val) {
                        setCurrentKey(null);
                      }
                    }}
                    content={item}
                    theme={defaultTags.includes(item) ? 'star' : 'primary'}
                    onClose={() => {
                      value.splice(index, 1);
                      onChange(value);
                    }}
                    showSettings={useAdvanced}
                    hasAdvancedConfig={useAdvanced && !!(value[index]?.KeyExpectedValue || value[index]?.KeyAuditPrompt)}
                    onSettings={(_, e) => handleOpenSettings(index, e)}
                  />
                );
              })
            }
            clearable
          />
        </Form.Item>
      ))}

      {/* 高级模式下的字段配置抽屉 */}
      {useAdvanced && (
        <FieldConfigDrawer
          key={drawerKey}
          visible={drawerVisible}
          fieldData={currentFieldData}
          onClose={handleDrawerClose}
          onConfirm={handleDrawerConfirm}
        />
      )}
    </>
  );
}

export default InputTagRenderer;
